export const language = {
	myName: 'Faiz Hirani',
	title: 'Software Engineer (Agility Specialist)',
	titleMobile: 'Software Engineer',
	subtitleMobile: '(Agility Specialist)',
};
